import {helpers} from "vuelidate/lib/validators";
const config = {
    app: {
        prefix: "armuserreg",
        host: "https://adc.arm.gov/armuserreg" // TODO:Change this if we ever change the host
    },
    api: {
        url: "https://user-reg-api.svcs.arm.gov" // TODO: This will change if proxied
    },
    auth: {
        url: "https://adc.arm.gov/Auth",
        keycloakURL: "https://keycloak.svcs.arm.gov/auth",
        realm: "Kubernetes",
        clientId: "datatools-oauth2",
        grantType: "password",
    },
    archiveServices: {
        url: "https://maintenance-check-api.svcs.arm.gov"
    },
    armgov: {
        url: "https://www.arm.gov"
    },
    bypassAuth: false,
    testUserId: 25703,
    elastic: {
        url: "https://datatools-elasticsearch.svcs.arm.gov",
    },
    identifiers: {
        crossref_id_prefix: "https://doi.org/10.13039/",
        ror_id_prefix: "https://ror.org/",
    },
    notificationService: {
        url: "https://notification-api.stg.arm.gov"
    },
    recaptchaSiteKey: "6LdzDTYUAAAAAL05blc17MfL5erA19qPaRfKngtH",
    validations: {
        zeroOrMoreValidator: helpers.regex("zeroOrMore", /^[^+=<>`'\"\\\/#^{};]*$/),
        nameValidator: helpers.regex("name", /^[^+=<>`'\"\\\/#^{};]+$/),
        zeroOrMoreSlashValidator: helpers.regex("zeroOrMore", /^[^+=<>`'\"\\#^{};]*$/),
        fundersValidator: helpers.regex("funders", /^[^+=<>`\"\\#^{};]+$/),
        oneOrMoreValidator: helpers.regex("oneOrMore", /^[^+=<>`'\"\\\/#^{};]+$/),
        emailValidator: helpers.regex("email", /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/),
        stateValidator: helpers.regex("state", /^[A-Z]{0,2}$/),
        usernameValidator: helpers.regex("username", /^(?=.{3,61}$)[a-z0-9]*[a-z]+[a-z0-9]*$/),
        institutionsValidator: helpers.regex("institutions", /^[^+=<>`\"\\#^{};]+$/),
        projectTitleValidator: helpers.regex("projectTitle", /^(?=.{4,250})[a-zA-Z0-9 ()-:'\",.\/]*[a-z]+[a-zA-Z0-9 ()-:'\",.\/]*$/),
    },
    orcid: {
        // NON Sandbox INFO
        authenticateUrl: "https://orcid.org/oauth/authorize",
        url: "https://orcid.org/",
        clientId: "APP-6X0JJQLQRFCIONX3",

        // SANDBOX INFO
        // authenticateUrl: "https://sandbox.orcid.org/oauth/authorize",
        // url: "https://sandbox.orcid.org/",
        // clientId: "APP-FDCFQU248WMBM3U1",

        // Switch to localhost for local development
        redirectUri: "https://adc.arm.gov/armuserreg",
        publicApiUrl: "https://pub.orcid.org/v3.0/",
        responseType: "token",
        scope: "openid",
        nonce: "whatever",
        userInfoCookie: "user_info_arm_user_registration",
        accessTokenCookie: "orcid_access_token_arm_user_registration",
        mailingListTokenCookie: "mailing_list_token_arm_user_registration",
    },
    allowedCharacters: "! @ $ % & * ( ) - _ [ ] : , . ? |",
    restrictedCharacters: "+ = < > ` ' \" \\ / # ^ { } ;",
    restrictedUsernameCharacters: "@ + = < > ` ' \" \\ / # ^ { } ;",
    restrictedFundersCharacters: "+ = < > ` \" \\ # ^ { } ;",
    restrictedSlashCharacters: "+ = < > ` ' \" \\ # ^ { } ;",
    restrictedInstitutionsCharacters: "+ = < > ` \" \\ # ^ { } ;",
    flagIcon: "src/assets/flag-icon.png",
}

export default config